/**
 * Case-insensitive, whitespace-trimmed duplicate-name check shared by the
 * activity and bundle name fields. Both compare a typed name against an
 * existing list, ignoring leading/trailing whitespace and case, and excluding
 * the entity currently being edited.
 */
export const isNameTakenBy = (items, name, excludeId) => {
    const normalized = (name || '').trim().toLowerCase();
    if (!normalized.length) {
        return false;
    }
    return (items || []).some(
        (item) => item.name?.trim().toLowerCase() === normalized && item.id !== excludeId
    );
};
